import * as React from 'react';
import BckLogo from "../../assets/logo/icon_black.png";

const StyledLogo = ({ logoProps, ...props }) => (
  <div
    sx={{
      width:'auto',
      height:'auto',
      cursor:'pointer',
      marginTop: {
        xs: 14,
        sm: 14,
        md: 20
      }
    }}
    {...props}
  >
    <img className="header-logo" style={{ width:'auto', height: 40, cursor: 'pointer', ...logoProps }} src={BckLogo} alt={"logo"}/>
  </div>
)

export default StyledLogo;
